import React, { useState, useEffect } from 'react';
import supabase from '../../helper/supabaseClient';
import { useUserProfile } from '../../helper/UserProfile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import MobileRevalNav from '../mobile/MobileRevalNav';

function Confirmation() {
    const { profile } = useUserProfile();

    const [confirmationUploading, setConfirmationUploading] = useState(false);
    const [discussionUploading, setDiscussionUploading] = useState(false);
    const [cMessage, setCMessage] = useState("");
    const [dMessage, setDMessage] = useState("");
    const [cError, setCError] = useState("");
    const [dError, setDError] = useState("");
    const [discussion, setDiscussion] = useState([]);
    const [confirmation, setConfirmation] = useState([]);

    useEffect(() => {
        if (profile?.id) {
            fetchDiscussion();
            fetchConfirmation();
        }
    }, [profile]);

    //Select File and Upload
    //Discussion
    const handleDiscussionSelectAndUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file || !profile?.id) {
        setDError('No file or user ID');
        return;
        }

        setDiscussionUploading(true);

        const filePath = `${profile.id}/${file.name}`;

        const { error } = await supabase.storage
        .from('reflective-discussion')
        .upload(filePath, file, {
            cacheControl: '3600',
            upsert: true,
        });

        if (error) {
        console.error(error);
        setDError('Upload failed. Please try again.');
        return;
        } 
        
        const { dbError } = await supabase
        .from('revalidation_documents')
        .insert({
            user_id: profile.id,
            document_type: "Reflective Discussion",
            file_path: filePath,
            upload_date: new Date(),
            bucket: "reflective-discussion"
        });

        if (dbError) {
            console.error(dbError);
            setDError("Database update failed.");
        } else {
        setDMessage('File uploaded successfully!');
        setDError("");
        await fetchDiscussion();
        }

        setDiscussionUploading(false);
    };

    const handleDiscussionClick = () => {
        document.getElementById('discussionInput').click();
    };

    //Confirmation
    const handleConfirmationSelectAndUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file || !profile?.id) {
        setCError('No file or user ID');
        return;
        }

        setConfirmationUploading(true);

        const filePath = `${profile.id}/${file.name}`;

        const { error } = await supabase.storage
        .from('reval-confirmation')
        .upload(filePath, file, {
            cacheControl: '3600',
            upsert: true,
        });

        if (error) {
        console.error(error);
        setCError('Upload failed. Please try again.');
        return;
        }
        
        const {dbError} = await supabase
        .from('revalidation_documents')
        .insert({
            user_id: profile.id,
            document_type: "Confirmation",
            file_path: filePath,
            upload_date: new Date(),
            bucket: "reval-confirmation"
        });

        if (dbError) {
            console.error(dbError);
            setCError("There has been an issue with the database update.")
        } else {
        setCMessage('File uploaded successfully!');
        setCError("");
        await fetchConfirmation();
        }

        setConfirmationUploading(false);
    };

    const handleConfirmationClick = () => {
        document.getElementById('confirmationInput').click();
    };

    //Delete
    //Discussion
    const handleDiscussionDelete = async (fileName) => {
        const { data, error } = await supabase
        .storage
        .from('reflective-discussion')
        .remove([`${profile.id}/${fileName}`]);

        if (error) {
            setDError("Failed to delete file");
            return;
        }
        
        const { dbError } = await supabase
        .from('revalidation_documents')
        .delete()
        .eq("file_path", [`${profile.id}/${fileName}`]);

        if (dbError) {
            setDError("Database update failed.")
        } else {
            setDMessage("File deleted");
            setDError("");
            await fetchDiscussion();
        }
    };

    //Confirmation
    const handleConfirmationDelete = async (fileName) => {
        const { data, error } = await supabase
        .storage
        .from('reval-confirmation')
        .remove([`${profile.id}/${fileName}`]);

        if (error) {
            setCError("Failed to delete file");
            return;
        }
        
        const { dbError } = await supabase
        .from('revalidation_documents')
        .delete()
        .eq("file_path", [`${profile.id}/${fileName}`]);

        if (dbError) {
            setCError("Database update failed.")
        } else {
            setCMessage("File deleted");
            setCError("");
            await fetchConfirmation();
        }
    };


    //Display list of files
    //Discussion
    const fetchDiscussion = async () => {
        const { data, error } = await supabase
        .storage
        .from('reflective-discussion')
        .list(profile.id);
    
        if (error) {
            console.error(error);
            setDError("Error fetching reflective discussion")
        } else {
            setDiscussion(data)
        }
    }

    //Confirmation
    const fetchConfirmation = async () => {
        const { data, error } = await supabase
        .storage
        .from('reval-confirmation')
        .list(profile.id);
    
        if (error) {
            console.error(error);
            setCError("Error fetching reflective discussion")
        } else {
            setConfirmation(data)
        }
    }
    
    return (
        <div>
            <div className="mob-only">
                <MobileRevalNav />
            </div> 
            <div className="dashboard-body">
            <h1>CONFIRMATION DOCUMENTS</h1>
            <div className="reflective-discussion">
                <h2>REFLECTIVE DISCUSSION FORM</h2>
                <p>You must use <a href="/reflective-discussion-form.doc" download="Reflective Discussion Form.doc" className="clickable-link">this form</a> to record your reflective discussion with another NMC-registered nurse or midwife about your five written reflective accounts.</p>
                <p>During your discussion you should not discuss patients, service users or colleagues in a way that could identify them unless they expressly agree, and in the discussion summary section below make sure you do not include any information that might identify a specific patient or service user.</p>
                <p>NOTE: Please delete discussion forms that falls outside of your revalidation window.</p>


                <div className="confirmation-grid">
                    <div className="reflective-1">
                        <span className="desktop-only"><a href="/reflective-discussion-form.doc" download="Reflective Discussion Form.doc"><button className="reflective" style={{marginRight: "1rem"}}>
                            <FontAwesomeIcon icon={faDownload} size="2xl" style={{paddingBottom: "10px"}}></FontAwesomeIcon>
                            Download Template
                        </button></a>
                        </span>
                        <input
                            id="discussionInput"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={handleDiscussionSelectAndUpload}
                            style={{display:"none"}}
                        />
                        <button className="reflective" onClick={handleDiscussionClick} disabled={discussionUploading}>
                            <FontAwesomeIcon icon={faArrowUpFromBracket} size="2xl" style={{paddingBottom: "10px"}}></FontAwesomeIcon>
                            
                            Upload Form
                        </button>
                        <br></br>
                        {dMessage && <p>{dMessage}</p>}
                        {dError && <p>{dError}</p>}
                    </div>

                    <div className="reflective-3 mob-block">
                        <table className="confirmation">
                            <thead>
                                <tr>
                                    <th>File Name</th>
                                    <th>Upload Date</th>
                                    <th style={{width:"1rem", backgroundColor:"#fff"}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {discussion.map((entry, index) => (
                                    <tr key={index}>
                                        <td><a href={`https://dyuqmgoqgozadkxqnqqq.supabase.co/storage/v1/object/public/reflective-discussion/${profile.id}/${entry.name}`} target="_blank" style={{fontSize:"0.9rem"}}>{entry.name}</a></td>
                                        <td>
                                            {new Date(entry.created_at).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric',
                                            })}
                                        </td>
                                        <td><FontAwesomeIcon icon={faTrashCan} style={{fontSize:"0.8rem"}} onClick={() => handleDiscussionDelete(entry.name)}/>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <br></br>
            <br></br>

            <div className="confirmation-discussion">
                <h3>CONFIRMATION FORM</h3>
                <p>You must use <a href="/confirmation-form.doc" download="Confirmation Form.doc" className="clickable-link">this form</a> to record your confirmation.</p>
                <p>NOTE: Please delete confirmation forms that falls outside of your revalidation window.</p>

                <div className="confirmation-grid">
                    <div className="reflective-1">
                        <span className="desktop-only"><a href="/confirmation-form.doc" download="Confirmation Form.doc"><button className="reflective"style={{marginRight: "2rem"}}>
                            <FontAwesomeIcon icon={faDownload} size="2xl" style={{paddingBottom: "10px"}}></FontAwesomeIcon>
                            Download Template
                        </button></a></span>

                        <input
                            id="confirmationInput"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={handleConfirmationSelectAndUpload}
                            style={{display:"none"}}
                        />
                        <button className="reflective" onClick={handleConfirmationClick} disabled={confirmationUploading}>
                            <FontAwesomeIcon icon={faArrowUpFromBracket} size="2xl" style={{paddingBottom: "10px"}}></FontAwesomeIcon>
                            Upload Form
                        </button>
                        <br></br>
                        {cMessage && <p>{cMessage}</p>}
                        {cError && <p>{cError}</p>}
                    </div>


                    <div className="reflective-2 mob-block">
                        <table className="confirmation">
                            <thead>
                                <tr>
                                    <th>File Name</th>
                                    <th>Upload Date</th>
                                    <th style={{width:"1rem", backgroundColor:"#fff"}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {confirmation.map((entry, index) => (
                                    <tr key={index}>
                                        <td><a href={`https://dyuqmgoqgozadkxqnqqq.supabase.co/storage/v1/object/public/reval-confirmation/${profile.id}/${entry.name}`} target="_blank" style={{fontSize:"0.9rem"}}>{entry.name}</a></td>
                                        <td>
                                            {new Date(entry.created_at).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric',
                                            })}
                                        </td>
                                        <td><FontAwesomeIcon icon={faTrashCan} style={{fontSize:"0.8rem"}} onClick={() => handleConfirmationDelete(entry.name)}/>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="mob-bottom-buffer">
        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
  )
}

export default Confirmation